import {post} from './http';

export type TranslatedSegment = {
  // Honestly nullable: a null element in the request (no current caller sends one) echoes back as
  // null rather than a real translation. Matches the C# TranslatedSegmentResponse.TranslatedText.
  translated_text: string | null;
  detected_source_language: string | null;
  from_cache: boolean;
};

export type TranslateResponse = {
  translations: TranslatedSegment[];
};

export const translationsApi = {
  // Text in, text out - not keyed on an item id. The single-submission page builds items
  // client-side with no server-side row, and the shared ItemMeta component (which renders
  // description/tags across four other surfaces) is never handed an item id either. One endpoint
  // over raw text covers every surface with no id plumbing, and lets a repeated segment (e.g. a
  // channel's boilerplate description) dedupe server-side regardless of which item it came from.
  translate: async (texts: string[], targetLanguage = 'en') =>
    post<{texts: string[]; target_language: string}, TranslateResponse>('/translations', {
      texts,
      target_language: targetLanguage
    })
};
